export const Spacing = {
	xxs: '0.25rem',
	xs: '0.5rem',
	sm: '0.75rem',
	md: '1rem',
	lg: '1.5rem',
	xl: '2rem',
	xxl: '2.5rem',
	threeXl: '3rem',
	fiveXl: '4rem',
	sevenXl: '5rem',
	tenXl: '6.5rem',
	elevenXl: '7.5rem',
};
